import { render } from "./DocModal.vue?vue&type=template&id=97fe5786&scoped=true"
import script from "./DocModal.vue?vue&type=script&lang=js"
export * from "./DocModal.vue?vue&type=script&lang=js"

import "./DocModal.vue?vue&type=style&index=0&id=97fe5786&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-97fe5786"]])

export default __exports__
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';import ClosePopup from 'quasar/src/directives/close-popup/ClosePopup.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QCardSection,QIcon});qInstall(script, 'directives', {ClosePopup});
